module.exports = __webpack_public_path__ + "media/2-25b.9c9061da.mp4";